/* eslint-disable react-hooks/exhaustive-deps */
// @see https://github.com/facebook/create-react-app/issues/6880
import React, { useEffect } from "react";
import { BackboneModel } from "../utils/cropr";

const none = () => {};

/**
 * Use `setInstance` to get hold of the BackboneView instance
 *
 * const Component = () => {
 *   const [backbones, setBackBones] = useState({});
 *
 *   // do something with backbone instance here:
 *   const value = backbones?.some.getValue();
 *
 *   return (
 *     <div>
 *       <BackboneComponent
 *         view={View.SomeView}
 *         setInstance={(instance) => setBackBones(...backbones, some: instance)
 *       />
 *     </div>
 *   )
 * }
 *
 *
 */

interface BackboneComponentProps {
  id: string;
  view: Backbone.View<Backbone.Model>;
  model: BackboneModel;
  setInstance?: (value: any) => void;
  getProps?: (model: BackboneModel) => any;
}

export const BackboneComponent = ({
  id,
  view,
  model,
  setInstance = none, // hiermee krijg je een reference naar de 'raw' Backbone View instance
  getProps = none, // props die je alleen tijdens initialisatie wilt ophalen, niet als component props
  ...props
}: BackboneComponentProps & any) => {
  useEffect(() => {
    const instance = new view({
      el: `#${id}`,
      ...getProps(model),
      ...props,
    });
    instance.render();
    setInstance(instance);
    return () => {
      setInstance(null);
      instance.remove();
    };
  }, [model]); // kon wel eens niet werken met hot-reload?

  return <div id={id} />;
};
export default BackboneComponent;
